import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Camera, ChevronLeft, ChevronRight } from 'lucide-react';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/9w1qrQM9hij1uLR7pBdwJY/junk4.png',
  alt: 'Retaining wall construction by EITHAN',
  label: 'Retaining Wall'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bhEJ9rHKMe9xtXEbAfe6qC/junk5.png',
  alt: 'Fence installation by EITHAN',
  label: 'Fence Installation'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h3GetCV9nBfkLmFeWqaopa/junk6.png',
  alt: 'Gravel and landscape prep by EITHAN',
  label: 'Landscape Prep'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bSWMSxXDZtSPUvDYXF9MZK/junk7.png',
  alt: 'Deck construction by EITHAN',
  label: 'Deck Build'
}];
export function GallerySection() {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const openLightbox = (index: number) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);
  const goNext = () => {
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex + 1) % galleryImages.length);
    }
  };
  const goPrev = () => {
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex - 1 + galleryImages.length) % galleryImages.length);
    }
  };
  return <section className="py-20 md:py-24 bg-brand-dark relative overflow-hidden" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-78">
          <div className="inline-flex items-center justify-center p-3 bg-brand-gold/10 rounded-full mb-4 text-brand-gold" data-id="element-79">
            <Camera size={32} data-id="element-80" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-81">
            Our Work Speaks For Itself
          </h2>
          <p className="text-lg text-brand-gold font-medium" data-id="element-82">
            Real projects. Real results. Real happy homeowners.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-83">
          {galleryImages.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative cursor-pointer rounded-xl overflow-hidden border border-brand-gold/10 hover:border-brand-gold/40 transition-all duration-300 aspect-square" onClick={() => openLightbox(index)} data-id="element-84">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-85" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-300 flex items-end" data-id="element-86">
                <div className="p-4 w-full translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-87">
                  <span className="text-white font-semibold text-sm md:text-base" data-id="element-88">
                    {image.label}
                  </span>
                </div>
              </div>
              {/* Gold corner accent */}
              <div className="absolute top-0 right-0 w-0 h-0 border-t-[40px] border-t-brand-gold/0 border-l-[40px] border-l-transparent group-hover:border-t-brand-gold/80 transition-all duration-300" data-id="element-89"></div>
            </motion.div>)}
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-90">
        {selectedIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4" onClick={closeLightbox} data-id="element-91">
            <button onClick={closeLightbox} className="absolute top-6 right-6 p-2 text-white/70 hover:text-white transition-colors z-10" data-id="element-92">
              <X size={32} data-id="element-93" />
            </button>

            <button onClick={e => {
          e.stopPropagation();
          goPrev();
        }} className="absolute left-4 md:left-8 p-3 text-white/50 hover:text-brand-gold transition-colors z-10" data-id="element-94">
              <ChevronLeft size={40} data-id="element-95" />
            </button>

            <button onClick={e => {
          e.stopPropagation();
          goNext();
        }} className="absolute right-4 md:right-8 p-3 text-white/50 hover:text-brand-gold transition-colors z-10" data-id="element-96">
              <ChevronRight size={40} data-id="element-97" />
            </button>

            <motion.div key={selectedIndex} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} transition={{
          duration: 0.3
        }} className="max-w-4xl max-h-[85vh] w-full" onClick={e => e.stopPropagation()} data-id="element-98">
              <img src={galleryImages[selectedIndex].src} alt={galleryImages[selectedIndex].alt} className="w-full h-auto max-h-[80vh] object-contain rounded-xl" data-id="element-99" />
              <p className="text-center text-brand-gold font-semibold mt-4 text-lg" data-id="element-100">
                {galleryImages[selectedIndex].label}
              </p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}